import { useEffect, useState } from "react";
import { waitHint } from "../wait-hint.ts";

/** 模型调用进行中显示已等待时长。`active` 变真时从 0 计时,变假时收起。 */
export function WaitHint({ active, working }: { active: boolean; working?: string }): React.JSX.Element | null {
  const [seconds, setSeconds] = useState(0);
  useEffect(() => {
    setSeconds(0);
    if (!active) return;
    const started = Date.now();
    const timer = setInterval(() => setSeconds((Date.now() - started) / 1000), 1000);
    return () => clearInterval(timer);
  }, [active]);
  const text = active ? waitHint(seconds, working) : "";
  return text ? <p className="muted" role="status">{text}</p> : null;
}
